var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKioskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 19C10.3498 19 8.93734 18.8875 7.76234 18.6625C6.58734 18.4375 5.99984 18.1667 5.99984 17.85V17H4.17484C3.5915 17 3.09984 16.7833 2.69984 16.35C2.29984 15.9167 2.12484 15.4083 2.17484 14.825L2.84984 6.825C2.88317 6.30833 3.0915 5.875 3.47484 5.525C3.85817 5.175 4.3165 5 4.84984 5H19.1498C19.6832 5 20.1415 5.175 20.5248 5.525C20.9082 5.875 21.1165 6.30833 21.1498 6.825L21.8248 14.825C21.8748 15.4083 21.6998 15.9167 21.2998 16.35C20.8998 16.7833 20.4082 17 19.8248 17H17.9998V17.85C17.9998 18.1667 17.4123 18.4375 16.2373 18.6625C15.0623 18.8875 13.6498 19 11.9998 19ZM4.17484 15H19.8248L19.1498 7H4.84984L4.17484 15Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKioskIcon);
export default __webpack_public_path__ + "static/media/kiosk_icon.cad3f1268b94976548ddd8c882dde5a9.svg";
export { ForwardRef as ReactComponent };